export enum UnsupportedUploadMediaKind {
  Image = 'image',
  Video = 'video',
  Audio = 'audio',
  Other = 'other',
}
